export default __webpack_public_path__ + "static/media/Bg.c573e087.png";